import MuiDivider, { DividerProps } from '@mui/material/Divider';
import { Breakpoint, styled } from '@mui/material/styles';
import React from 'react';

type Props = DividerProps & {
  breakpoint?: Breakpoint;
  hideAtBreakpoint?: boolean;
};

const StyledDivider = styled(MuiDivider, {
  shouldForwardProp: (prop) =>
    prop !== 'breakpoint' && prop !== 'hideAtBreakpoint',
})<{ breakpoint?: Breakpoint; hideAtBreakpoint?: boolean }>(
  ({ theme, breakpoint, hideAtBreakpoint }) => ({
    ...(breakpoint && {
      [theme.breakpoints.down(breakpoint)]: {
        ...(hideAtBreakpoint
          ? { display: 'none' }
          : {
              alignSelf: 'auto',
              borderRightWidth: 0,
              borderBottomWidth: 'thin',
              height: 0,
              width: '100%',
            }),
      },
    }),
  }),
);

const Divider: React.FC<Props> = ({
  breakpoint,
  hideAtBreakpoint,
  ...rest
}) => (
  <StyledDivider
    breakpoint={breakpoint}
    hideAtBreakpoint={hideAtBreakpoint}
    {...rest}
  />
);

export default Divider;
